import { Action } from '@ngrx/store';

export enum DataLayerActionTypes {
  Persist = '[DataLayer] Persist',
  Flush = '[DataLayer] Flush'
}

/**
 * Persist an object to the data layer.
 */
export class Persist implements Action {
  readonly type = DataLayerActionTypes.Persist;
  constructor(public payload: Object) {}
}

export class Flush implements Action {
  readonly type = DataLayerActionTypes.Flush;
  constructor() {}
}

export type DataLayerActions = Persist | Flush;
